import * as React from 'react'

import type { DiscussionVisibility } from 'types/discussion'
import type { EditableTrack, TrackId } from 'types/track'

import TrackDiscussions from './discussions'
import BulkTrackDiscussions from './discussions/bulk-track-discussions'

export type TrackCommentsProps = {
  editedTrack: EditableTrack & {
    trackIds?: TrackId[]
  }
  trackDurationSeconds?: number
  notesVisibility: DiscussionVisibility
  onNotesVisibilityChange: (visibility: DiscussionVisibility) => void
  targetDiscussionId?: number
}

export type Props = TrackCommentsProps

const TrackComments = ({
  editedTrack,
  trackDurationSeconds,
  notesVisibility,
  onNotesVisibilityChange,
  targetDiscussionId,
}: Props): React.ReactElement | null => {
  const trackId = editedTrack?.id

  // single track
  if (typeof trackId === 'number') {
    return (
      <TrackDiscussions
        trackId={trackId}
        trackDurationSeconds={trackDurationSeconds}
        visibility={notesVisibility}
        onVisibilityChange={onNotesVisibilityChange}
        targetDiscussionId={targetDiscussionId}
      />
    )
  }

  // bulk edit
  const trackIds = editedTrack?.trackIds
  if (trackIds && trackIds.length > 0) {
    return (
      <BulkTrackDiscussions
        trackIds={trackIds}
        visibility={notesVisibility}
        onVisibilityChange={onNotesVisibilityChange}
      />
    )
  }
  return null
}

export default TrackComments
